import React from "react";

// Original Morning Sunday Teer brand mark: a bullseye target pierced by two crossed arrows.
export function Logo({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="Morning Sunday Teer logo"
    >
      <circle cx="30" cy="34" r="20" fill="#0f172a" />
      <circle cx="30" cy="34" r="15" fill="#ffffff" />
      <circle cx="30" cy="34" r="10" fill="#ff4500" />
      <circle cx="30" cy="34" r="4.5" fill="#0f172a" />
      {/* arrow 1 */}
      <g stroke="#0f172a" strokeWidth="2.4" strokeLinecap="round">
        <line x1="30" y1="34" x2="58" y2="8" />
        <line x1="30" y1="34" x2="52" y2="16" stroke="#ff4500" strokeWidth="2.4" />
      </g>
      <path d="M58 8 L50 9 L55 15 Z" fill="#ff4500" />
      <path d="M58 8 L60 16 L52 13 Z" fill="#f97316" />
      {/* arrow 2 */}
      <g stroke="#0f172a" strokeWidth="2.4" strokeLinecap="round">
        <line x1="30" y1="34" x2="54" y2="14" />
      </g>
    </svg>
  );
}

export function LogoLockup({ compact = false }) {
  return (
    <span className="flex items-center gap-2">
      <Logo size={compact ? 42 : 48} />
      <span className="font-head font-extrabold leading-none whitespace-nowrap text-lg sm:text-2xl">
        <span className="brand-gradient-text">Morning </span>
        <span className="text-slate-900">Sunday Teer</span>
      </span>
    </span>
  );
}
